import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/url/';

class UrlService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllByFiltro(idCliente, filtro, tipo) {
        return axios.get(API_URL + 'all?idCliente=' + idCliente + '&filtro=' + filtro + '&tipo=' + tipo, { headers: this.headers });
    }

    findAllPrincipalByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'allPrincipal?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    findAllItemByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'allItem?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
    }

    save(url) {
        return axios.post(API_URL, JSON.stringify(url),
            { headers: this.headers });
    }

    get(urlId) {
        return axios.get(API_URL + urlId, { headers: this.headers });
    }

    remove(urlId) {
        return axios.delete(API_URL + urlId, { headers: this.headers });
    }

    getUrlGpi(urlId) {
        return axios.get(API_URL + 'getUrlGpi/' + urlId, { headers: this.headers });
    }


}

export default new UrlService();